import React from 'react';
import BoutiqueText from "./BoutiqueText";

const textContent = [
  { text: "Yak" },
  { text: "Boutique" },
  { text: "we are bodios" }
];

function BoutiqueHeader() {
  return (
    <header
      className="flex flex-col text-center text-black uppercase"
      role="banner"
    >
      {/* Үндсэн дэвсгэр өнгө болон тохиргоо */}
      <div className="flex overflow-hidden flex-col justify-center items-center px-5 py-[60px] lg:py-[99px] w-full bg-[#FFF]">
        
        {/* Текст хэсэг */}
        <div className="flex flex-col items-center gap-[25px] max-w-full w-[1015px] text-center cursor-pointer text-[90px] max-md:text-4xl" style={{ fontFamily: "'Githera Regular', sans-serif", lineHeight: '95.4px' }}>
          {textContent.map((item, index) => (
            <BoutiqueText key={index} text={item.text} isFirst={index === 0} />
          ))}
        </div>

      </div>
    </header>
  );
}

export default BoutiqueHeader;